export default __webpack_public_path__ + "img/google_play-6417cb042bda7df9582fb280c474c4f6.png";